interface BuildUpdateBannerProps {
  isApplyingUpdate: boolean;
  onApplyUpdate: () => void;
}

const BuildUpdateBanner = (props: BuildUpdateBannerProps) => {
  return (
    <div className="fixed inset-x-0 top-0 z-[2000] px-4 pt-4">
      <div className="mx-auto flex max-w-5xl flex-col gap-4 rounded-[24px] border border-sky-200 bg-white/95 px-5 py-4 shadow-[0_20px_60px_rgba(15,23,42,0.18)] backdrop-blur md:flex-row md:items-center md:justify-between md:px-6">
        <div className="flex items-start gap-4">
          <div className="mt-0.5 flex size-11 shrink-0 items-center justify-center rounded-full bg-sky-100 text-sky-700 shadow-inner">
            <svg
              aria-hidden="true"
              className="size-5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 12a9 9 0 1 1-2.64-6.36" />
              <path d="M21 3v6h-6" />
            </svg>
          </div>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-slate-900 md:text-[15px]">
              Une mise a jour de l&apos;application est disponible
            </p>
            <p className="mt-1 text-sm leading-6 text-slate-600">
              Rechargez l&apos;application pour utiliser la derniere version.
            </p>
          </div>
        </div>

        <button
          className="inline-flex min-h-11 shrink-0 items-center justify-center rounded-full bg-slate-900 px-5 text-sm font-medium text-white transition hover:bg-slate-700 disabled:cursor-not-allowed disabled:bg-slate-500"
          disabled={props.isApplyingUpdate}
          onClick={props.onApplyUpdate}
          type="button"
        >
          {props.isApplyingUpdate
            ? "Mise a jour en cours..."
            : "Mettre a jour maintenant"}
        </button>
      </div>
    </div>
  );
};

export default BuildUpdateBanner;
